
import { defineComponent } from 'vue';
import ReportOptionComponent from "@/components/reportsComponents/ReportOption.vue";
import SettingsList from '@/views/SettingsList.vue';
import PaymentSetting from '@/views/PaymentSetting.vue';

export default defineComponent({
    name: "SettingsPage",

    components: { ReportOptionComponent, SettingsList, PaymentSetting },

    data() {
        return {
            statusComponent: "Menu",
            options: [
                {
                    title: "تنظیمات کارمزد",
                    path: "settings",
                    icon: 'mdi-cog-outline'
                },
                {
                    title: "تنظیمات تسویه حساب",
                    path: "paymentSetting",
                    icon: 'mdi-cog-outline'
                }
            ]
        }
    },

    methods: {
        changeStatusComponent(status: string): void {
            this.$router.push({
                query: { ...this.$route.query, path: status },
            });

            switch (status) {
                case "settings":
                    this.statusComponent = "settings";
                    break;
                    
                case "paymentSetting":
                    this.statusComponent = "paymentSetting";
                    break;

                default:
                    this.statusComponent = "Menu";
                    // Optionally clear the query parameter or set to default
                    this.$router.push({
                        query: { ...this.$route.query, path: undefined },
                    });
                    break;
            }
        },

        resetStatusComponent(): void {
            this.statusComponent = "Menu";
        },

        selectedOption(option: { title: string, path: string, icon: string }): void {
            this.changeStatusComponent(option.path)
        }
    },

    // Watch for route changes to update statusComponent
    watch: {
        "$route.query.path"(newPath: string) {
            if (newPath && newPath !== this.statusComponent) {
                this.changeStatusComponent(newPath);
            }

            if (!newPath) {
                this.resetStatusComponent();
            }
        },
    },
})
